/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/OrganizationItemLightPaginationSlice', 'model/OpencorporatesOrganizationPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/OrganizationItemLightPaginationSlice'), require('../model/OpencorporatesOrganizationPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.OpencorporatesOrganizationApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.OrganizationItemLightPaginationSlice, root.ForStractionServiceApi.OpencorporatesOrganizationPaginationSlice);
  }
}(this, function(ApiClient, OrganizationItemLightPaginationSlice, OpencorporatesOrganizationPaginationSlice) {
  'use strict';

  /**
   * OpencorporatesOrganization service.
   * @module api/OpencorporatesOrganizationApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new OpencorporatesOrganizationApi. 
   * @alias module:api/OpencorporatesOrganizationApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the opencorporatesOrganizationAutocompleteNameGet operation.
     * @callback module:api/OpencorporatesOrganizationApi~opencorporatesOrganizationAutocompleteNameGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrganizationItemLightPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * autocompleteName
     * @param {String} _4SAPIAppID 
     * @param {String} searchValue 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {String} opts.countryCode  (default to )
     * @param {module:api/OpencorporatesOrganizationApi~opencorporatesOrganizationAutocompleteNameGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/OrganizationItemLightPaginationSlice}
     */
    this.opencorporatesOrganizationAutocompleteNameGet = function(_4SAPIAppID, searchValue, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling opencorporatesOrganizationAutocompleteNameGet";
      }

      // verify the required parameter 'searchValue' is set
      if (searchValue == undefined || searchValue == null) {
        throw "Missing the required parameter 'searchValue' when calling opencorporatesOrganizationAutocompleteNameGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'searchValue': searchValue,
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'countryCode': opts['countryCode']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = OrganizationItemLightPaginationSlice;

      return this.apiClient.callApi(
        '/OpencorporatesOrganization/autocompleteName', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the opencorporatesOrganizationExtendedSearchGet operation.
     * @callback module:api/OpencorporatesOrganizationApi~opencorporatesOrganizationExtendedSearchGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OpencorporatesOrganizationPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * extendedSearch
     * @param {String} _4SAPIAppID 
     * @param {Object} opts Optional parameters
     * @param {String} opts.name  (default to )
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {module:api/OpencorporatesOrganizationApi~opencorporatesOrganizationExtendedSearchGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/OpencorporatesOrganizationPaginationSlice}
     */
    this.opencorporatesOrganizationExtendedSearchGet = function(_4SAPIAppID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling opencorporatesOrganizationExtendedSearchGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'name': opts['name'],
        'startID': opts['startID'],
        'maxCount': opts['maxCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = OpencorporatesOrganizationPaginationSlice;

      return this.apiClient.callApi(
        '/OpencorporatesOrganization/extendedSearch', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
